import { Component, OnDestroy, OnInit, Inject, NgZone, OnChanges, SimpleChanges, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, ApplicationRef, ComponentFactoryResolver, Injector, Renderer2, ViewContainerRef, QueryList, ViewChildren, EventEmitter, Output, Input, ViewEncapsulation } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Store } from '@ngrx/store';
import { IPageData } from '../../../interfaces/page-data';
import { IAppState } from '../../../interfaces/app-state';
import { HttpService } from '../../../services/http/http.service';
import * as PageActions from '../../../store/actions/page.actions';
import { Options } from 'ng5-slider';
import { HttpErrorResponse } from '@angular/common/http';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subject, forkJoin, throwError, Observable, interval, of } from 'rxjs'
import { ActivatedRoute, Router, Route } from '@angular/router';
import { Spinkit } from 'ng-http-loader'; // <============
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page';
import 'rxjs/Rx';
import { TCModalService } from 'src/app/ui/services/modal/modal.service';
import { Content } from 'src/app/ui/interfaces/modal';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { BottomSheetGuestLogin } from '../order-menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { stringify } from 'querystring';
import { LoginService } from "src/app/layout/components/login-form/login-form.service";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'food-menu-page',
  templateUrl: './food-menu.component.html',
  styleUrls: ['./food-menu.component.scss'],

})
export class FoodMenuComponent extends BasePageComponent implements OnInit, OnDestroy {
  iconmenu = './assets/img/menu.svg';
  iconAtvmenu = './assets/img/greymenu.svg';

  iconcart = './assets/img/green_cart.svg';
  iconAtvcart = './assets/img/cart.svg';

  iconorder = './assets/img/green_orders.svg';
  iconAtvorder = './assets/img/order.svg';

  iconprofile = './assets/img/greenprofile.svg';
  iconAtvprofile = './assets/img/profile.svg';
  desc
  query
  myOptions = {
    'placement': 'right',
  }
  value: number = 0;
  pageData: IPageData;
  // value: number = 0;
  public spinkit = Spinkit;
  More
  more
  errorMessage
  restoID
  toggle;
  allergenceArray = []
  diestPrefArray = []
  changeColorallergens = [];
  changeColordiet = []
  changeColors = []
  showmenus
  searchText
  allDietDatas
  allAllergDatas
  products: any
  totalcartvalue = 0;
  // totalcartvalues = 0
  valueOrder
  conditionToDisaply = false
  orders = []
  UserCondition
  menuData;
  menuDataMains;
  menuDataAll = []
  menuDataDesert = []
  menuDataStarter = []
  menuDataMain = []
  menuDatastarter;
  ids;
  listfArrayDesert = []
  listfArrayStarter = []
  listfArrayMain = []
  token
  maindata
  tableids
  dishType = []
  guestCCdish
  userCC
  customisedishType
  clickedIndex
  DishIDValue
  postReviewdata
  errorReviewdata
  reviewSafe
  review_total
  DishId
  getdataIn
  ingredintstatus
  postreviewStatus
  public totalSubject = new Subject()
  public orderSubject = new Subject()
  apiresponse1: Object;
  apiresponse2: Object;
  errorMessages
  ingredints
  listIngredient = []
  eatYes
  eatNo
  deliverStatus
  restoDeatils
  userName
  seletedname = []
  userName_loggedin
  allergenselect
  restaurant_name
  infoView: boolean = false;
  showminus: boolean = false;
  restodesc = [];
  linkresto
  my_note
  mynote_status
  showMorelink: boolean = false;
  buttonmore: boolean = true;
  user_Name: any;
  linkinsta: any;
  linkfb: any;
  UserCC
  orders_addon
  restaurant_nutri_status
  resto_logo: any;
  verified: any;
  isguest: boolean = false
  guest_dishdetail: any;
  user_dishdetail: any;
  ShowStarters: boolean = false;
  dish_ID: any;
  dynamicIDs;
  showfoodPreferences: boolean = false;
  showFoodMenu: boolean = false;
  userPreferenceForm: FormGroup;
  addOrAddBtnCondition = true;
  restoOnlineStatus: boolean = true
  sortedDispalyFlag: boolean = true
  qrCodeBackDisable: boolean = true
  nutriInfoFlag: boolean = true
  allergenMsg: any;
  constructor(store: Store<IAppState>,
    public httpSv: HttpService,
    private router: Router,
    private route: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    private modal: TCModalService,
    private _location: Location,
    private modalService: NgbModal,
    private changeDetectorRef: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
    super(store, httpSv);
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: 'food-menu',
          route: 'food-menu'
        }
      ]
    };

  }
  ngOnChanges(): void {
    if (this.cartLength) {
      this.sub = interval(500)
        .subscribe((val) => {
          this.cartLength = sessionStorage.getItem('orders-data');
          this.length = JSON.parse(this.cartLength)
          this.counts = this.length?.map((item: any) => {
            return item.indexVal
          })
          this.lengths = this.counts?.length
        });
    }
    else {
      this.counts = 0;
    }
  }
  showAllergenDialog() {
    const dialogRef = this.dialog.open(AllergensMsgDialog, {
      panelClass: 'allergen_msg_dialog',
      hasBackdrop: true,
      disableClose: true,
      data: this.allergenMsg
    })
  }
  cartLength
  length
  counts
  lengths
  sub
  newItems: any = {};
  selectedItemId
  selectedCityIds

  spiceTollerence = 0;
  values: number = 0;
  options: Options = {
    floor: 0,
    ceil: 4
  };
  showAddOnlyBtn: boolean = false;
  restoBranchFlag: boolean = false;
  restoBranchCurrentId
  restoBranchData = []

  isL0Resto: boolean = true;
  newRestoId: any;
  async ngOnInit() {

    if (sessionStorage.getItem('claim_id') && sessionStorage.getItem('claim_id') != 'null' && sessionStorage.getItem('claim_id') != 'undefined') {
      this.newRestoId = sessionStorage.getItem('claim_id');
      this.isL0Resto = false;
    }



    this.showFoodMenu = true;
    this.showAddOnlyBtn = true;
    this.showfoodPreferences = false;
    this.ids = sessionStorage.getItem('restoIds')
    this.tableids = sessionStorage.getItem('tableIds')
    this.restoID = sessionStorage.getItem("restoId")

    await this.getMenuAllLabels(this.restoID)
    this.FetchUserPrefernces();

    this.token = sessionStorage.getItem('access_token')
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    if (sessionStorage.getItem('qrCode') == 'true') {
      this.qrCodeBackDisable = false
    }
    if (!this.restoID) {
      if (this.UserCondition) this.router.navigate(['horizontal/aggregator'])
      else this.router.navigate(['/vertical/aggregator'])
    }
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
    let ords = JSON.parse(sessionStorage.getItem('orders-data'));
    if (ords && ords.length) {
      this.conditionToDisaply = true;
      this.orders = ords;
    }
    let savedUserData = JSON.parse(sessionStorage.getItem('savedData'));
    if (savedUserData && savedUserData.length) {
      this.dishes = savedUserData;
    }
    if (this.router.url == '/public/food-menu' && this.httpSv.showPrefChoseFlag) {
      this.router.navigate(['/public/choose-preference'])
      this.qrCodeBackDisable = false
    }
    this.sub = interval(500)
      .subscribe((val) => {
        this.cartLength = sessionStorage.getItem('orders-data');
        this.length = JSON.parse(this.cartLength)
        this.counts = this.length?.map((item: any) => {
          return item.indexVal
        })
        this.lengths = this.counts?.length
      });
    if (sessionStorage.getItem('restoId') == '46') {
      this.sortedDispalyFlag = false
      this.changeDetectorRef.detectChanges()
    }

  }

  isDefaultMenuLabel: boolean = true
  menuLabel: any
  selectedMenuLabelId: any

  addOwnMenu() {
    this.httpSv.addOwnMenu(this.newRestoId).subscribe((res: any) => {
      if (res['status']) {
        let redirectUrl = res['redirect_url'];
        if (redirectUrl) {
          window.open(redirectUrl, '_blank');
        }
      }
      else {
        this._snackBar.open("Your restaurant is not approved yet. Please try again after approval", 'Close', {
          duration: 2000,
        });
      }
    }, err => {
      this._snackBar.open("Your restaurant is not approved yet. Please try again after approval", 'Close', {
        duration: 2000,
      });
    })
  }


  async getMenuAllLabels(restoId) {
    try {
      const res = await this.httpSv.getAllMenuLabels(restoId).toPromise()
      if (res['status']) {
        if (res['result'].data.length > 0) {
          this.isDefaultMenuLabel = false
          this.menuLabel = res['result'].data
          this.selectedMenuLabelId = this.menuLabel[0].id
          this.changeDetectorRef.detectChanges()
        }
      }
    }
    catch (err) {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    }
  }

  changeManuLabel(label: any) {
    this.selectedMenuLabelId = label.id
    this.showndata = this.showndataWithLabelId[label.id]
    let dishNames = this.showndata.map((item: any) => {
      return item.dish_type_name
    })
    this.uniqueCategories = dishNames.filter((item, i, ar) => ar.indexOf(item) === i);
    this.newItems = new Map(this.groupByType(this.showndata));
    this.test = new Map();
    console.log(this.newItems)
    for (let [key, value] of this.newItems) {
      if (this.newItems.get(key)[0].topChoice) {
        const sortedArray = this.newItems.get(key)
        const getPriority = obj => {
          if (obj.topChoice === 'Yes' && obj.canEat === null && obj.dpAvailable === null) return 1;
          if (obj.topChoice === 'Yes' && obj.canEat === null && obj.dpAvailable === 'Yes') return 2;
          if (obj.topChoice === 'Yes' && obj.canEat === 'Yes' && obj.dpAvailable === null) return 3;
          if (obj.topChoice === 'Yes' && obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 4;
          if (obj.topChoice === 'No' && obj.canEat === null && obj.dpAvailable === null) return 5;
          if (obj.topChoice === 'No' && obj.canEat === null && obj.dpAvailable === 'Yes') return 6;
          if (obj.topChoice === 'No' && obj.canEat === 'Yes' && obj.dpAvailable === null) return 7;
          if (obj.topChoice === 'No' && obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 8;
          return 9; // Rest
        };
        sortedArray.sort((a, b) => {
          const priorityA = getPriority(a);
          const priorityB = getPriority(b);
          return priorityA - priorityB;
        });

        this.test.set(key, sortedArray)
      }
      else {
        const sortedArray = this.newItems.get(key)
        const getPriority = obj => {
          if (obj.canEat === null && obj.dpAvailable === null) return 1;
          if (obj.canEat === null && obj.dpAvailable === 'Yes') return 2;
          if (obj.canEat === 'Yes' && obj.dpAvailable === null) return 3;
          if (obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 4;
          return 5; // Rest
        };
        sortedArray.sort((a, b) => {
          const priorityA = getPriority(a);
          const priorityB = getPriority(b);
          return priorityA - priorityB;
        });

        this.test.set(key, sortedArray)
      }

    }
    this.newItems = new Map(this.test);
    console.log('showndata', this.showndata);
    this.changeDetectorRef.detectChanges()
  }

  changeResto(id) {
    console.log('func called');
    if (id == this.restoBranchCurrentId) return
    sessionStorage.setItem('restoIDCopy', id)
    this.restoBranchCurrentId = id
    this.httpSv.restoBranchCurrentId = this.restoBranchCurrentId
    let foodmenuobj = {
      restaurantId: id,
      allergens_id: this.allergensarry,
      dietry_preferences: this.dietaryarry,
      ingredents_prefereces: this.ingredientbind,
      spice_rating: this.spiceTollerence
    }
    this.httpSv.showmenu(foodmenuobj).subscribe(data => {
      if (sessionStorage.getItem('restoId') == '46') {
        this.sortedDispalyFlag = false
        this.changeDetectorRef.detectChanges();
      }
      if (data['result'].data) {
        this.showndata = data['result'].data.dishes;
        let temp: any = {};

        this.showndata.forEach((item: any) => {
          const id = item.menu_names_id;
          temp[id] = temp[id] || [];
          temp[id].push(item);
        })

        console.log('temp', temp)


      }
      this.restoDetails = data['result'].data.restaurantDetails;
      // this.restoName = this.restoDetails.restaurant_name;
      // sessionStorage.setItem("restoName", this.restoName);
      this.restoAdd = this.restoDetails.restaurant_address;
      this.restoDescription = this.restoDetails.restaurant_detail;
      this.addonExistsBool = this.restoDetails.addonExists;
      this.optionsExistsBool = this.restoDetails.optionsExists;
      this.nutriInfoFlag = this.restoDetails.restaurant_nutri_status == 'Active' ? true : false
      this.allergenMsg = this.restoDetails.allergens_msg
      if (data['result'].data.restaurantDetails.restaurant_image)
        this.restoLogo = data['result'].data.restaurantDetails.restaurant_image
      if (this.restoDetails.restaurant_online_status === 'Inactive' || this.restoDetails.restaurant_online_status == null) {
        this.restoOnlineStatus = false
      }
      let dishNames = this.showndata.map((item: any) => {
        return item.dish_type_name
      })
      this.uniqueCategories = dishNames.filter((item, i, ar) => ar.indexOf(item) === i);
      this.newItems = new Map(this.groupByType(this.showndata));
      console.log('1st', this.newItems)
      for (let [key, value] of this.newItems) {
        console.log('2nd', this.newItems.get(key));

        if (this.newItems.get(key)[0].topChoice) {
          const sortedArray = this.newItems.get(key)
          const getPriority = obj => {
            if (obj.topChoice === 'Yes' && obj.canEat === null && obj.dpAvailable === null) return 1;
            if (obj.topChoice === 'Yes' && obj.canEat === null && obj.dpAvailable === 'Yes') return 2;
            if (obj.topChoice === 'Yes' && obj.canEat === 'Yes' && obj.dpAvailable === null) return 3;
            if (obj.topChoice === 'Yes' && obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 4;
            if (obj.topChoice === 'No' && obj.canEat === null && obj.dpAvailable === null) return 5;
            if (obj.topChoice === 'No' && obj.canEat === null && obj.dpAvailable === 'Yes') return 6;
            if (obj.topChoice === 'No' && obj.canEat === 'Yes' && obj.dpAvailable === null) return 7;
            if (obj.topChoice === 'No' && obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 8;
            return 9; // Rest
          };
          sortedArray.sort((a, b) => {
            const priorityA = getPriority(a);
            const priorityB = getPriority(b);
            return priorityA - priorityB;
          });

          this.test.set(key, sortedArray)
        }
        else {
          const sortedArray = this.newItems.get(key)
          const getPriority = obj => {
            if (obj.canEat === null && obj.dpAvailable === null) return 1;
            if (obj.canEat === null && obj.dpAvailable === 'Yes') return 2;
            if (obj.canEat === 'Yes' && obj.dpAvailable === null) return 3;
            if (obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 4;
            return 5; // Rest
          };
          sortedArray.sort((a, b) => {
            const priorityA = getPriority(a);
            const priorityB = getPriority(b);
            return priorityA - priorityB;
          });

          this.test.set(key, sortedArray)
        }

      }
      this.newItems = new Map(this.test);
      console.log('topChocice', this.newItems)
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  asIsOrder(a, b) {
    return 1;
  }
  showndata
  showndataWithLabelId: any
  dishID: any
  addtocartitem(dishIds: any, name: any) {
    let addToCartObj = {
      restaurantId: this.restoID,
      dishId: dishIds,
      quantity: "1"
    }
    this.httpSv.addToCart(addToCartObj).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.conditionToDisaply = true
      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
    })
  }
  checkToCart() {
    this.router.navigate(['horizontal/order-menu']);
  }
  foodAllergens

  showPreference() {
    this.router.navigate(['/horizontal/preference']);
    this.showFoodMenu = false;
    this.showfoodPreferences = true;
  }

  showOnScreenPreferences: boolean = false;
  showPreferences() {
    if (!sessionStorage.getItem('access_token')) {
      this.router.navigate(['/public/choose-preference']);
    }
    else {
      this.router.navigate(['/horizontal/choose-preference']);
    }
  }

  foodAllergenss
  foodAllnss: any[] = []
  userAllergens = []
  allergensarry = []
  fetchedUserPreferences
  load: boolean = false;
  user_preferences: any;
  user_preference_spice: any;
  userIngredients: any;
  userDislikes: any;
  userDietary: any;
  dietaryarry = [];
  ingredientbind = [];
  userDislikesbind = [];
  user_ingredients: [];
  alldietary = [];
  allAllergens = [];
  FetchUserPrefernces() {
    this.httpSv.getUserPreferences().subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.fetchedUserPreferences = res['result'].data;
        this.userAllergens = this.fetchedUserPreferences.user_preference_allergens;
        this.userDietary = this.fetchedUserPreferences.user_preference_dietary;
        this.userIngredients = this.fetchedUserPreferences.user_preference_ingredient
        this.userDislikes = this.fetchedUserPreferences.user_preference_dislike
        this.spiceTollerence = this.fetchedUserPreferences.user_preference_spice;
        if (Array.isArray(this.userAllergens)) {
          this.userAllergens.forEach(element => {
            this.allergensarry.push(element.allergens_id)
          })
        }
        else {
          this.allergensarry = []
        }
        if (Array.isArray(this.userDietary)) {
          this.userDietary.forEach(element => {
            this.dietaryarry.push(element.diet_preference_id)
          })
        }
        else {
          this.userDietary = []
        }
        if (Array.isArray(this.userIngredients)) {
          this.userIngredients.forEach(element => {
            this.ingredientbind.push(element.sub_ingredient_id)
          });
        }
        else {
          this.userIngredients = []
        }
        if (Array.isArray(this.userDislikes)) {
          this.userDislikes.forEach(element => {
            this.userDislikesbind.push(element.sub_ingredient_id)
          });
        }
        else {
          this.userDislikes = []
        }
        if (this.UserCondition) {
          this.showmenudata()
        } else {
          this.showmenuGet();
        }
      } else {
        this.showmenudata()
      }
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
      this.showmenudata()
      console.log(err);
    })

  }
  dietPref = []
  restoDetails
  restoName
  restoAdd
  restoDescription
  addonExistsBool: boolean = false;
  optionsExistsBool: boolean = false;
  uniqueCategories
  test: any = new Map()
  showmenudata() {
    let foodmenuobj
    if (!sessionStorage.getItem('access_token')) {
      foodmenuobj = {
        restaurantId: this.restoID,
        allergens_id: this.httpSv.allergenceArray,
        dietry_preferences: this.httpSv.diestPrefArray,
        ingredents_prefereces: this.ingredientbind,
        spice_rating: this.httpSv.spiceTollerence
      }
    }
    else {
      foodmenuobj = {
        restaurantId: this.restoID,
        allergens_id: this.allergensarry,
        dietry_preferences: this.dietaryarry,
        ingredents_prefereces: this.ingredientbind,
        spice_rating: this.spiceTollerence
      }
    }
    if (foodmenuobj.allergens_id.length > 0 || foodmenuobj.dietry_preferences.length > 0 || foodmenuobj.ingredents_prefereces.length > 0 || foodmenuobj.spice_rating != 0) {
      if (!this.httpSv.showPrefChoseFlag && !sessionStorage.getItem('_declaimer')) {
        let ratingSheet = this._bottomSheet.open(BottomSheetDeclaimer, {
          data: { name: 'name' },
          disableClose: true
        })
      }
    }
    this.httpSv.showmenu(foodmenuobj).subscribe(data => {
      if (sessionStorage.getItem('restoId') == '46') {
        this.sortedDispalyFlag = false
        this.changeDetectorRef.detectChanges();
      }
      if (data['result'].data.restaurantDetails.branches) {
        this.restoBranchFlag = true
        this.restoBranchCurrentId = sessionStorage.getItem('restoId')
        if (this.httpSv.restoBranchCurrentId == null)
          this.httpSv.restoBranchCurrentId = this.restoBranchCurrentId
        this.restoBranchData = [{ restaurant_id: this.restoBranchCurrentId, label: data['result'].data.restaurantDetails.label, restaurant_name: data['result'].data.restaurantDetails.restaurant_name }]
        data['result'].data.restaurantDetails.branches.forEach(element => {
          this.restoBranchData.push(element)
        });
      }
      else {
        console.log('set null');

        this.httpSv.restoBranchCurrentId = null
      }
      this.showndata = data['result'].data.dishes;

      this.showndataWithLabelId = {};

      this.showndata.forEach((item: any) => {
        const id = item.menu_names_id;
        this.showndataWithLabelId[id] = this.showndataWithLabelId[id] || [];
        this.showndataWithLabelId[id].push(item);
      })

      if (!this.showndataWithLabelId[1]) {
        this.showndata = this.showndataWithLabelId[this.selectedMenuLabelId]
      }


      this.restoDetails = data['result'].data.restaurantDetails;
      this.restoName = this.restoDetails.restaurant_name;
      this.nutriInfoFlag = this.restoDetails.restaurant_nutri_status == 'Active' ? true : false
      this.allergenMsg = this.restoDetails.allergens_msg
      if (this.httpSv.restoBranchCurrentId && this.httpSv.restoBranchCurrentId != this.restoBranchCurrentId) {
        this.changeResto(this.httpSv.restoBranchCurrentId)
        return
      }
      sessionStorage.setItem("restoName", this.restoName);
      this.restoAdd = this.restoDetails.restaurant_address;
      this.restoDescription = this.restoDetails.restaurant_detail;
      this.addonExistsBool = this.restoDetails.addonExists;
      this.optionsExistsBool = this.restoDetails.optionsExists;
      if (data['result'].data.restaurantDetails.restaurant_image)
        this.restoLogo = data['result'].data.restaurantDetails.restaurant_image
      if (this.restoDetails.restaurant_online_status === 'Inactive' || this.restoDetails.restaurant_online_status === null) {
        this.restoOnlineStatus = false
      }
      let dishNames = this.showndata.map((item: any) => {
        return item.dish_type_name
      })
      this.uniqueCategories = dishNames.filter((item, i, ar) => ar.indexOf(item) === i);
      this.newItems = new Map(this.groupByType(this.showndata));
      console.log(this.newItems)
      for (let [key, value] of this.newItems) {
        if (this.newItems.get(key)[0].topChoice) {
          const sortedArray = this.newItems.get(key)
          const getPriority = obj => {
            if (obj.topChoice === 'Yes' && obj.canEat === null && obj.dpAvailable === null) return 1;
            if (obj.topChoice === 'Yes' && obj.canEat === null && obj.dpAvailable === 'Yes') return 2;
            if (obj.topChoice === 'Yes' && obj.canEat === 'Yes' && obj.dpAvailable === null) return 3;
            if (obj.topChoice === 'Yes' && obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 4;
            if (obj.topChoice === 'No' && obj.canEat === null && obj.dpAvailable === null) return 5;
            if (obj.topChoice === 'No' && obj.canEat === null && obj.dpAvailable === 'Yes') return 6;
            if (obj.topChoice === 'No' && obj.canEat === 'Yes' && obj.dpAvailable === null) return 7;
            if (obj.topChoice === 'No' && obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 8;
            return 9; // Rest
          };
          sortedArray.sort((a, b) => {
            const priorityA = getPriority(a);
            const priorityB = getPriority(b);
            return priorityA - priorityB;
          });

          this.test.set(key, sortedArray)
        }
        else {
          const sortedArray = this.newItems.get(key)
          const getPriority = obj => {
            if (obj.canEat === null && obj.dpAvailable === null) return 1;
            if (obj.canEat === null && obj.dpAvailable === 'Yes') return 2;
            if (obj.canEat === 'Yes' && obj.dpAvailable === null) return 3;
            if (obj.canEat === 'Yes' && obj.dpAvailable === 'Yes') return 4;
            return 5; // Rest
          };
          sortedArray.sort((a, b) => {
            const priorityA = getPriority(a);
            const priorityB = getPriority(b);
            return priorityA - priorityB;
          });

          this.test.set(key, sortedArray)
        }

      }
      this.newItems = new Map(this.test);
      console.log('topChocice', this.newItems)
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  filteredFoodDishType
  groupByType(arr) {
    if (sessionStorage.getItem('restoId') == '46') {
      let map = new Map(arr.map(({ dish_type_name }) => [dish_type_name, { dish_type_name, color: [] }]));
      for (let { dish_type_name } of arr);
      let result = [...map.values()];
      this.filteredFoodDishType = result;
      let temp = arr.reduce((r, a) => {
        r[a.dish_type_name] = r[a.dish_type_name] || [];
        r[a.dish_type_name].push(a);
        return r;
      }, Object.create(null));
      let seqArr = ['Hot Beverages', 'Non Alcoholic beverages', 'Desserts', 'Food menu', 'Cocktail', 'Draft Beer', 'Bottle Cider', 'Bottle Beer', 'Spirits - Vodka', 'Spirits - Gin', 'Spirits - Rum', 'Spirits - Whiskey', 'Wine']
      // let seqArr = ['Desserts', "Small plates", "Sides", "Large plates","Pizza","Smoothie","Lunch bowls & sandwich","Juice","Fast Lunch"]
      let filterData = new Map()
      for (let i = 0; i < seqArr.length; i++) {
        // filterData[seqArr[i]] = temp[seqArr[i]]
        filterData.set(seqArr[i], temp[seqArr[i]])
      }
      temp = filterData
      return temp
    }
    else {
      let map = new Map(arr.map(({ dish_type_name }) => [dish_type_name, { dish_type_name, color: [] }]));
      for (let { dish_type_name } of arr);
      let result = [...map.values()];
      this.filteredFoodDishType = result;
      let temp = new Map()
      let reduce = arr.reduce((r, a) => {
        r[a.dish_type_name] = r[a.dish_type_name] || [];
        r[a.dish_type_name].push(a);
        return r;
      }, Object.create(null));
      console.log('-->r', reduce)
      for (const item in reduce) {
        console.log(item)
        temp.set(item, reduce[item])
      }
      return temp
    }
  }
  allergenceArrayNumbers = []
  // values = 0;
  handleMinus() {
    this.values--;
  }
  handlePlus() {
    this.values++;
  }
  backClicked() {
    this.router.navigate(['public/guest-user']);
  }
  backClickedUser() {
    this.router.navigate(['/horizontal/choose-preference']);
  }

  table_num

  getData(url: string, dataName: string, callbackFnName?: string) {
    this.httpSv.getData(url).subscribe(
      data => {
        this[dataName] = data;
      },
      err => {
      },
      () => {
        (callbackFnName && typeof this[callbackFnName] === 'function') ? this[callbackFnName](this[dataName]) : null;
      }
    );
  }

  backToFoodMenu() {
    this.showFoodMenu = true;
    this.showfoodPreferences = false;
  }
  backHome() {
    if (this.UserCondition) {
      this.router.navigate(['/horizontal/aggregator']);
    } else {
      this.router.navigate(['/public/aggregator'])
    }
  }

  closeModals() {
    this.modal.close();
  }

  getLoginScreen() {
    if (this.UserCondition) {
      this.UserCondition = true;
      this.router.navigate(['/horizontal/food-menu'])
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }
  }

  allAllergensArray: any[] = [];
  restoDietaryArray: any[] = [];
  favouritesIngredientsArray: any[] = [];
  dislikeIngredientsArray: any[] = [];

  getAllAllergens(restoID) {
    this.httpSv.getRestaurantAllergens(restoID).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.allAllergensArray = res['result'].data;
      }
      this.FetchUserPrefernces();
    }, (err: any) => {
      console.log(err);
    })
  }

  showErrorimg: boolean = false;
  valuechange(val: any) {
    if (val) {
      this.showErrorimg = true
    }
  }

  getAllRestoDietary(restoID) {
    this.httpSv.getRestaurantDietray(restoID).subscribe((res: any) => {
      if (res['status'] == 'TRUE') {
        this.restoDietaryArray = res['result'].data;
      }
    }, (err: any) => {
      console.log(err);
    })
  }

  getAllDislikesAndFavoritesIngredients() {
    this.httpSv.getDislikesAndFavorites().subscribe((res: any) => {
      if (res['status'] == 'TRUE') {
        this.favouritesIngredientsArray = res['result'];
        this.dislikeIngredientsArray = res['result'];
      }
    }, (err: any) => {
      console.log(err);
    })
  }
  restoLogo = null


  showmenuGet() {
    let foodmenuobj = {
      restaurantId: this.restoID,
      allergens_id: this.allergensarry,
      dietry_preferences: this.dietaryarry,
      ingredents_prefereces: this.ingredientbind,
      spice_rating: this.spiceTollerence
    }
    if (foodmenuobj.allergens_id.length > 0 || foodmenuobj.dietry_preferences.length > 0 || foodmenuobj.ingredents_prefereces.length > 0 || foodmenuobj.spice_rating != 0) {
      if (!this.httpSv.showPrefChoseFlag && !sessionStorage.getItem('_declaimer')) {
        let ratingSheet = this._bottomSheet.open(BottomSheetDeclaimer, {
          data: { name: 'name' },
          disableClose: true
        })
      }
    }
    this.httpSv.showmenu(foodmenuobj).subscribe(data => {
      if (sessionStorage.getItem('restoId') == '46') {
        this.sortedDispalyFlag = false
        this.changeDetectorRef.detectChanges();
      }
      this.showndata = data['result'].data.dishes;

      let temp: any = {};

      this.showndata.forEach((item: any) => {
        const id = item.menu_names_id;
        temp[id] = temp[id] || [];
        temp[id].push(item);
      })

      console.log('temp3', temp)

      this.restoDetails = data['result'].data.restaurantDetails;
      this.restoName = this.restoDetails.restaurant_name;
      sessionStorage.setItem("restoName", this.restoName);
      this.restoAdd = this.restoDetails.restaurant_address
      this.restoDescription = this.restoDetails.restaurant_detail
      this.addonExistsBool = this.restoDetails.addonExists;
      this.optionsExistsBool = this.restoDetails.optionsExists;
      this.nutriInfoFlag = this.restoDetails.restaurant_nutri_status == 'Active' ? true : false
      this.allergenMsg = this.restoDetails.allergens_msg
      if (data['result'].data.restaurantDetails.restaurant_image)
        this.restoLogo = data['result'].data.restaurantDetails.restaurant_image
      let dishNames = this.showndata.map((item: any) => {
        return item.dish_type_name
      })
      this.uniqueCategories = dishNames.filter((item, i, ar) => ar.indexOf(item) === i);
      this.newItems = new Map(this.groupByType(this.showndata));
      this.changeDetectorRef.detectChanges()

    })
  }

  top_choice
  topChoice_yes
  topChoice_no
  TopChoice
  src_img = './assets/img/Dish_details_black.png'


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
  }

  goToAllRestaurants() {
    this.router.navigate(['/horizontal/resto'])
  }

  private destroyed = false;
  dishdetails_guestrarray = []
  dishdetails_userarray = []
  ngOnDestroy() {
    this.destroyed = true;
    this.store.dispatch(new PageActions.Reset());
    this.changeDetectorRef.detach();
    sessionStorage.removeItem('qrCode')
  }
  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }

  setLoaded(during: number = 0) {
    setTimeout(() => this.store.dispatch(new PageActions.Update({ loaded: true })), during);
  }
  dish = []
  dishes = [];
  addToCartDone(indexValue, quantity, propductId) {
    if (!this.restoOnlineStatus) {
      return
    }
    if (quantity != 0) {
      const itemindex = this.dishes.findIndex(obj => obj["food_dish_id"] == propductId);
      if (itemindex > -1) {
        this.dishes[itemindex]["quantity"] = quantity
      }
      else {
        let one = { "quantity": quantity, "food_dish_id": propductId };
        this.dishes.push(one);

      }
    }
    else {
      const itemindex = this.dishes.findIndex(obj => obj["food_dish_id"] == propductId);
      if (itemindex > -1) {
        this.dishes.splice(itemindex, 1);
      }
    }
    sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
  }

  removeMinusFunc(id, index) {
    let local = JSON.parse(sessionStorage.getItem('orders-data'))
    let reqIndex = local.findIndex(ele => ele.food_dish_id == id)
    if (local[reqIndex]['rdaoop_id']) {
      let lastIndex = local.findLastIndex(ele => ele.food_dish_id == id)
      local.splice(lastIndex, 1)
      let length = local.filter(ele => ele.food_dish_id == id).length
      if (length == 0) this.addOrAddBtnCondition = true
    }
    else {
      local[reqIndex].quantity -= 1
      if (local[reqIndex]['quantity'] == 0) {
        local.splice(reqIndex, 1)
        this.addOrAddBtnCondition = true;
      }
      else {
        let temp = local[reqIndex]['quantity']
        document.getElementById(`countQuantity${index}`).innerText = temp
      }
    }
    this.orders = local
    sessionStorage.setItem('orders-data', JSON.stringify(local))
    // let temp = this.getQuantity(id)

  }
  addBtnFunc(id, index) {
    let local = JSON.parse(sessionStorage.getItem('orders-data'))
    let reqIndex = local.findIndex(ele => ele.food_dish_id == id)
    let isAddonExists = local[reqIndex].rdaoop_id;
    if (isAddonExists) {
      this.httpSv.getDishDetailsForAddon(this.restoID, id).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.dishDetailsResponse = res['result'];
          this.dishAddons = res['result'].dish_addons;
          let data = {
            food_dish_id: id,
            addonArray: this.dishDetailsResponse,
            flag: true
          }
          let sheetRefs = this._bottomSheet.open(BottomSheetAddon, {
            data: data
          });

          sheetRefs.afterDismissed().subscribe((dataFromChild) => {
            if (dataFromChild) {
              let temp = parseInt(document.getElementById(`countQuantity${index}`).innerText) + 1
              document.getElementById(`countQuantity${index}`).innerText = temp.toString()
            }
          });
        }
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      })
    } else {
      local[reqIndex].quantity += 1
      this.orders = local
      let temp = local[reqIndex]['quantity']
      document.getElementById(`countQuantity${index}`).innerText = temp
    }
    sessionStorage.setItem('orders-data', JSON.stringify(local))
  }

  getQuanNumber(dishId) {
    for (let orderse of this.orders) {
      if (orderse.food_dish_id == dishId) {
        this.showbtn = true;
        if (orderse.rdaoop_id) {
          let temp = this.orders.filter(ele => ele.food_dish_id == dishId)
          return temp.length
        } else {
          return orderse.quantity
        }
      }
    }
  }




  passDataToService() {
    this.dishes = JSON.parse(sessionStorage.getItem("savedData"));
    this.httpSv.dishes.next(this.dishes); // here you emit 
    if (this.UserCondition) {
      this.router.navigate(['horizontal/order-menu']);
    }
    else {
      this.router.navigate(['public/order-menu-guest']);
    }
    sessionStorage.setItem("isGuestShowMyOrderClicked", "true");
  }
  removeCartDone(quantity, propductId) {
    if (quantity != 0) {
      this.dishes.push({ "quantity": quantity, "food_dish_id": propductId })
    }
    else {
      var removeIndex = this.dishes.map(item => item.quantity).indexOf(0);
      this.dishes.splice(removeIndex, 1);
    }
    let ords_add = JSON.parse(sessionStorage.getItem('addon-orders'));
    if (ords_add) {
      let array_bind = ords_add.concat(this.orders)
      sessionStorage.setItem("orders-data", JSON.stringify(array_bind));
    }
    else {
      sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
      sessionStorage.setItem('FianlArray', JSON.stringify(this.FinalArray));
    }

  }
  totalprice
  FinalArray = []
  totalcartvalues = 0;
  dishAddons: any[] = []
  dishDetailsResponse
  checkAddon(index, items) {
    console.log(items, '-s-s-s-s-s-')
    if (!this.restoOnlineStatus) {
      this._snackBar.open('Sorry, This restaurant is currently not taking online order')
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000)
    }
    else {


      this.addOrAddBtnCondition = false
      let isAddonExists = items.addOnExists;
      let isOptionsExists = items.optionsExists;
      if ((isAddonExists || isOptionsExists) && this.UserCondition) {
        this.httpSv.getDishDetailsForAddon(this.restoID, items.id).subscribe((res: any) => {
          if (res['status'] == "TRUE") {
            this.dishDetailsResponse = res['result'];
            this.dishAddons = res['result'].dish_addons;
            let data = {
              food_dish_id: items.id,
              addonArray: this.dishDetailsResponse,
              flag: false,
              epos_Id: items.epos_product_id
            }
            let sheetRefs = this._bottomSheet.open(BottomSheetAddon, {
              data: data
            });

            sheetRefs.afterDismissed().subscribe((dataFromChild) => {
              this.lengths = dataFromChild?.lengths;
              this.getQuantitys(dataFromChild?.food_dish_id)
              this.conditionToDisaply = true;
              this.query = ''
            });
          }
        }, (err: any) => {
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        })
      } else {
        this.addToCart(index, items.id, items.name, items.price, items.price, items.epos_product_id)
      }
    }
  }

  getQuantitys(dishId) {
    let ords = JSON.parse(sessionStorage.getItem('orders-data'));
    this.orders = ords;
    for (let orderse of this.orders) {
      if (orderse.food_dish_id == dishId) {
        return orderse.quantity
      }
    }
  }

  addToCart(indexValue, propductId, name, price, originalPrice, epos_Id) {
    //conditions to display +  and - buttons
    if (this.UserCondition) {
      this.totalcartvalues += 1;
      let count = 1
      let push = true
      for (let ords of this.orders) {
        if (ords.food_dish_id == propductId) {
          ords.quantity++;
          // ords.originalPrice = parseInt(originalPrice)
          ords.Price = parseInt(ords.Price)
          ords.Price = ords.Price + parseInt(originalPrice)
          push = false
          this.conditionToDisaply = true
          if (ords.rdaoop_id) {
            ords.rdaoop_id.map(element => {
              return element.addonQuantity++
            });
          }
        }
      }
      if (push) {
        this.dish
        this.orders.push({ "indexVal": indexValue, "quantity": count, "food_dish_id": propductId, "Name": name, "Price": price, "originalPrice": originalPrice, epos_product_id: epos_Id })
        this.FinalArray.push({ "indexVal": indexValue, "quantity": count, "food_dish_id": propductId, "Name": name, "Price": price, "originalPrice": originalPrice, epos_product_id: epos_Id });
        sessionStorage.setItem('FianlArray', JSON.stringify(this.FinalArray));
        sessionStorage.setItem("count", JSON.stringify(this.orders));
        this.conditionToDisaply = true
      }
      sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
      sessionStorage.setItem("count", JSON.stringify(this.orders.length));
      this.sub = interval(500)
        .subscribe((val) => {
          this.cartLength = sessionStorage.getItem('orders-data');
          this.length = JSON.parse(this.cartLength)
          this.counts = this.length?.map((item: any) => {
            return item.indexVal
          })
          this.lengths = this.counts?.length
        });
      this.getQuantity(propductId)
      this.conditionToDisaply = true
      this._snackBar.open(name + " added to cart");
      setTimeout(() => {
        this._snackBar.dismiss();
      }, 2000);
    }
    else {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
      if (this.UserCondition) {
        this.UserCondition = true;
      } else {
        let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        });
      }

    }
  }
  removeFromCart(dishId) {
    // this.infoView = false
    this.totalcartvalue -= 1;
    for (let ord of this.orders) {
      if (ord.food_dish_id == dishId) {
        ord.quantity -= 1
        ord.Price = parseInt(ord.Price) - parseInt(ord.originalPrice);
      }
    }
    this.orders.filter((v, i) => {
      if (v.quantity == 0) {
        this.orders.splice(i, 1);
      }
    })
    let ords_add = JSON.parse(sessionStorage.getItem('addon-orders'));
    if (ords_add) {
      let array_bind = ords_add.concat(this.orders)
      sessionStorage.setItem("orders-data", JSON.stringify(array_bind));
    }
    else {
      sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
    }
  }
  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
          window.location.reload()
        }
      }
    )
  }
  //get quanity
  dishesh = []
  orderse
  showbtn: boolean = false;
  // dietPref = []
  getQuantity(dishId) {
    for (let orderse of this.orders) {
      if (orderse.food_dish_id == dishId) {
        this.showbtn = true;
        return orderse.quantity
      }
    }

  }
  cleareCartData() {
    sessionStorage.removeItem("orders-data");
    sessionStorage.removeItem("savedData");
    this.orders = []
  }
  Startervalue
  starterBool: boolean = false;
  menuClick() {
    const data = {
      foodDishOption: this.showndata,
    }
    let sheetRef = this._bottomSheet.open(BottomSheetCategory, {
      data: this.uniqueCategories,
    });

    sheetRef.afterDismissed().subscribe((dataFromChild) => {
      this.Startervalue = dataFromChild;
      let dishessss = this.filteredFoodDishType.map((item: any) => {
        return item.dish_type_name
      }).sort()

      if (this.Startervalue == 'All') {
        const ele = document.getElementById('id_' + dishessss[0])
        ele.scrollIntoView()
      } else {
        const ele = document.getElementById('id_' + this.Startervalue)
        ele.scrollIntoView()
      }

    });
  }

  ScrollToParticularDiv(dataFromChild) {
    var divElement = document.getElementById('id_' + dataFromChild).scrollIntoView({ behavior: 'smooth' })
  }

  onClickMore() {
    this.showMorelink = true
    this.buttonmore = false
  }

  addonData
  food_dishes_option_id
  addonList = []
  quantity = 1
  foodOptionto_bottom = []

  goToRatingsBottomSheet(dishName, dishId) {
    if (this.UserCondition) {
      let data = {
        "foodDishName": dishName,
        "foodDishId": dishId

      }
      let ratingSheet = this._bottomSheet.open(BottomSheetRatings, {
        data: data
      })
    }
    else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }
  }

  goToDishDetails(dishName, dishId) {
    if (this.UserCondition) {
      let data = {
        "foodDishName": dishName,
        "foodDishId": dishId,
        "nutriInfoFlag": this.nutriInfoFlag

      }
      let ratingSheet = this._bottomSheet.open(BottomSheetKeyIngredients, {
        data: data
      })
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }

  }
  openMediaFunc(dishName, dishId) {
    if (this.UserCondition) {
      let data = {
        "foodDishName": dishName,
        "foodDishId": dishId,
        'media': true,
        "nutriInfoFlag": this.nutriInfoFlag

      }
      let ratingSheet = this._bottomSheet.open(BottomSheetKeyIngredients, {
        data: data
      })
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }
  }
  openDescriptionFunc(dishName, dishId) {
    if (this.UserCondition) {
      let data = {
        "foodDishName": dishName,
        "foodDishId": dishId,
        'discription': true,
        "nutriInfoFlag": this.nutriInfoFlag
      }
      let ratingSheet = this._bottomSheet.open(BottomSheetKeyIngredients, {
        data: data
      })
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }
  }

  openAllegenList(dishId: any) {
    if (this.UserCondition) {
      this.httpSv.getDishWiseAllergens(dishId).subscribe((res: any) => {
        if (res['status']) {
          const bottonSheetRef = this._bottomSheet.open(BottomAllegenList, {
            data: res.result
          })
        }
      })
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }


  }
  openAllergenChartDilog(category: any) {
    if (this.UserCondition) {
      this.httpSv.getCategoryWiseAllergenChart(window.atob(this.ids), category.key).subscribe((res: any) => {
        if (res['status']) {
          const dialogRef = this.dialog.open(AllergensChartDialog, {
            hasBackdrop: true,
            panelClass: 'allergen_chart_table',
            data: res.result
          })
        }
      })
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }

  }

  unsuitableAllergen(dish_id: any, dish_name: any) {
    if (this.UserCondition) {
      this.httpSv.getUnsuitableData(dish_id).subscribe((res: any) => {
        if (res['status']) {
          const bottonSheetRef = this._bottomSheet.open(UnsuitableBottomSheet, {
            data: {
              apiData: res.result,
              dish_name
            }
          })
        }
      })
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }
  }
}

@Component({
  selector: 'bottom-sheet-overview-example-sheet',
  templateUrl: 'bottom-sheet-overview-example-sheet.html',
})
export class BottomSheetOverviewExampleSheet implements OnInit {
  listfArrayDesert: any[];
  listfArrayStarter: any[];
  errorMessage
  listfArrayMain: any[];
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewExampleSheet>, public httpSv: HttpService,
    private route: ActivatedRoute, private router: Router) { }
  dataSource = this.data;
  maindata
  totalcartvalue = 0;
  datas
  allAllergDatas = []
  allDietDatas = []
  restoID
  conditionToDisaply = false
  totalcartvalues = 0
  values: number = 0;
  eatYes
  dish_ID
  orders = []
  UserCondition
  options: Options = {
    floor: 0,
    ceil: 4
  };
  guest_dishdetail
  user_obj: any;
  dishdetails_userarray = []
  dishdetails_guestrarray = []
  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  ngOnInit() {
    this.restoID = sessionStorage.getItem("restoId")
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.dish_ID = sessionStorage.getItem('dish_id')
    const dataAlleregy = sessionStorage.getItem("selectedAlleregence")
    this.allAllergDatas = JSON.parse("[" + dataAlleregy + "]");
    const dataDiet = sessionStorage.getItem("selectedDiestpref")
    this.allDietDatas = JSON.parse("[" + dataDiet + "]");
  }

  Spice_cust

  onChangeValue(event) {
    this.Spice_cust = event
  }
  dish = []
  dishes = [];
  removeCartDone(quantity, propductId) {
    if (quantity != 0) {
      this.dishes.push({ "quantity": quantity, "food_dish_id": propductId, "spice_rating": this.Spice_cust })
    }
    else {
      var removeIndex = this.dishes.map(item => item.quantity).indexOf(0);
      this.dishes.splice(removeIndex, 1);
    }
  }

  // totalcartvalues  = 0
  addToCart(propductId, catId) {
    //conditions to display +  and - buttons
    this.totalcartvalues += 1;
    let count = 1
    let push = true
    for (let ords of this.orders) {
      if (ords.food_dish_cat_id == catId && ords.food_dish_id == propductId) {
        ords.quantity++;
        push = false
        this.conditionToDisaply = true
      }
    }
    if (push) {
      this.dish
      this.orders.push({ "quantity": count, "food_dish_id": propductId, "food_dish_cat_id": catId, "spice_rating": this.Spice_cust ? this.Spice_cust : '0' })
      this.conditionToDisaply = true
    }
  }

  passDataToService() {
    this.bottomSheetRef.dismiss();
    sessionStorage.removeItem('dish_id')
    this.httpSv.dishes.next(this.dishes); // here you emit 
    if (this.UserCondition) {
      this.router.navigate(['horizontal/order-menu']);
    }
    else {
      this.router.navigate(['public/order-menu-guest']);
    }
    sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
  }
}

@Component({
  selector: 'bottom-sheet-overview-review',
  templateUrl: 'bottom-sheet-overview-review.html',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class BottomSheetOverviewReview implements OnInit {

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private changeDetectorRef: ChangeDetectorRef,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewReview>,
  ) {
  }

  ngOnInit() {
  }

}

@Component({
  selector: 'bottom-sheet-overview-note',
  templateUrl: 'bottom-sheet-overview-note.html',
})
export class BottomSheetOverviewNote implements OnInit {

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewNote>,
  ) {
  }
  ngOnInit() {

  }

}


@Component({
  selector: 'bottom-sheet-addon',
  templateUrl: 'bottom-sheet-addon.html',
  styleUrls: ['./food-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class BottomSheetAddon implements OnInit {
  ApiData
  restoID
  foodName
  options = []
  defaultSelected = 0
  selectedoption
  allAllergDatas
  dish_ID
  quantity = 1
  allDietDatas
  UserCondition
  addonList = []
  first_price
  option_ID
  spiceRating
  conditionToDisaply: boolean = false;
  More
  more
  orders = []
  select_value = []
  Addon_select
  addonListShow: boolean = false;
  food_dishes_option_id
  onchangePrice = true
  totalDishPriceAfterAddons
  optName
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router,
    private zone: NgZone,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetAddon>,
    public httpSv: HttpService,
    private _snackBar: MatSnackBar) {
  }
  ngOnInit() {
    console.log(this.data)
    this.ApiData = this.data;
    this.options = this.ApiData.addonArray.dish_options;
    this.foodName = this.ApiData.addonArray.name;
    this.addonList = this.ApiData.addonArray.dish_addons;
    this.epos_id = this.ApiData.epos_Id
    if (this.addonList.length > 0) {
      this.addonListShow = true;
    } else {
      this.addonListShow = false;
    }
    this.UserCondition = sessionStorage.getItem('access_token');
    this.restoID = sessionStorage.getItem('restoId');
    const dataAlleregy = sessionStorage.getItem("selectedAlleregence")
    this.orders = JSON.parse(sessionStorage.getItem('orders-data'))
    this.allAllergDatas = JSON.parse("[" + dataAlleregy + "]");
    const dataDiet = sessionStorage.getItem("selectedDiestpref")
    this.spiceRating = sessionStorage.getItem("spiceRating")
    this.allDietDatas = JSON.parse("[" + dataDiet + "]");
    this.first_price = this.options[0]?.option_price;
    this.option_ID = this.options[0]?.option_id;
    this.optName = this.options[0]?.option_name;
    this.dish_ID = this.options[0]?.rdo_dish_id;
    this.sendAddondetails(this.option_ID, this.optName, this.first_price, 0);
    console.log(this.addonListShow);

    this.changeDetectorRef.detectChanges();
  }
  // ngAfterViewInit(): void {
  //   //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
  //   //Add 'implements AfterViewInit' to the class.
  //   this.ApiData = this.data;
  //   this.options = this.ApiData.addonArray.dish_options;
  //   this.foodName = this.ApiData.addonArray.name;
  //   this.addonList = this.ApiData.addonArray.dish_addons;
  //   if (this.addonList) {
  //     this.addonListShow = true;
  //   } else {
  //     this.addonListShow = false;
  //   }
  //   this.UserCondition = sessionStorage.getItem('access_token');
  //   this.restoID = sessionStorage.getItem('restoId');
  //   const dataAlleregy = sessionStorage.getItem("selectedAlleregence")
  //   this.orders = JSON.parse(sessionStorage.getItem('orders-data'))
  //   this.allAllergDatas = JSON.parse("[" + dataAlleregy + "]");
  //   const dataDiet = sessionStorage.getItem("selectedDiestpref")
  //   this.spiceRating = sessionStorage.getItem("spiceRating")
  //   this.allDietDatas = JSON.parse("[" + dataDiet + "]");
  //   this.first_price = this.options[0]?.option_price;
  //   this.option_ID = this.options[0]?.option_id;
  //   this.optName = this.options[0]?.option_name;
  //   this.dish_ID = this.options[0]?.rdo_dish_id;
  //   this.sendAddondetails(this.option_ID, this.optName, this.first_price, 0);
  //   console.log('ngggg',this.options,this.foodName);
  //   this.changeDetectorRef.detectChanges()
  // }
  selection(id, dishid) {
    this.select_value = []
    this.onchangePrice = false
    this.dish_ID = dishid
    this.option_ID = id
    if (this.UserCondition) {
      this.httpSv.user_dishAddOnList(this.restoID, dishid, this.quantity, id).subscribe(res => {
        if (res['status'] == true) {
          this.first_price = res['result'].totalPrice
          this.addonList = res['result'].addOn
          this.changeDetectorRef.detectChanges();
        }
      })
      this.httpSv.user_calculatePrice(this.restoID, this.dish_ID, id, this.quantity, this.select_value).subscribe(res => {
        if (res['status'] == true) {
          this.first_price = res['result'].totalPrice
          this.changeDetectorRef.detectChanges();
        }
      })
    }
    else {
      this.httpSv.dishAddOnList(this.restoID, dishid, this.quantity, id,
        this.allAllergDatas, this.allDietDatas).subscribe(res => {
          if (res['status'] == true) {
            this.first_price = res['result'].totalPrice
            this.addonList = res['result'].addOn
            this.changeDetectorRef.detectChanges();
          }
        })
      this.httpSv.calculatePrice(this.restoID, this.dish_ID, id, this.quantity, this.select_value).subscribe(res => {
        if (res['status'] == true) {
          this.first_price = res['result'].totalPrice
          this.changeDetectorRef.detectChanges();
        }
      })
    }
  }

  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  checknox_id
  optionPriceBasedOnQuantity
  restaurant_dish_addon_optionId
  select_value_rdoop = []
  dishAddonArray: any[] = [];
  disableAddBtn: boolean = true;
  select_addons(id, rdip, addonName, addonprice, e) {
    this.checknox_id = id
    if (e.checked) {
      this.select_value.push(id)
      if (this.select_value.length > 0) {
        this.disableAddBtn = false;
      }
      let adddonObj = {
        addonId: id,
        addonName: addonName,
        addonPrice: addonprice,
        addonQuantity: 1,
        restaurant_dish_addon_optionId: rdip
      }
      this.select_value_rdoop.push(adddonObj);
      this.dishAddonArray = this.select_value;
      let addonObj = {
        restaurant_id: this.restoID,
        dish_id: this.ApiData.food_dish_id,
        quantity: 1,
        option_id: this.selectedOptId,
        dish_addon_id: this.dishAddonArray
      }
      this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.totalDishPriceAfterAddons = res.result.totalDishPrice;
          this.optionPriceBasedOnQuantity = res.result.optionPriceBasedOnQuantity;
          this.changeDetectorRef.detectChanges();
        }
      }, (err: any) => {
        console.log(err)
      })
    }
    else {
      let index = this.select_value.findIndex(ele => ele == id)
      this.select_value.splice(index, 1)
      if (this.select_value.length == 0) {
        this.disableAddBtn = true;
      }
      this.dishAddonArray = this.select_value;
      let addonObj = {
        restaurant_id: this.restoID,
        dish_id: this.ApiData.food_dish_id,
        quantity: 1,
        option_id: this.selectedOptId,
        dish_addon_id: this.dishAddonArray
      }
      this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.totalDishPriceAfterAddons = res.result.totalDishPrice;
          this.changeDetectorRef.detectChanges();
        }
      }, (err: any) => {
        console.log(err)
      })
    }
  }
  sub
  cartLength
  length
  counts
  lengths
  dataPass() {
    // if (this.ApiData.flag) {
    //   let temp = JSON.parse(sessionStorage.getItem("orders-data"))
    //   let reqIndex = temp.findIndex(ele => ele.option_name == 'min')
    //   // if(reqIndex != -1){
    //   //   temp[reqIndex].quantity += 1;
    //   //   temp[reqIndex].rdaoop_id.push()
    //   // }
    //   console.log(this.option_ID)
    // } else {
    if (this.orders == null) {
      // this.orders = []
      this.orders.push({
        "food_dish_id": this.ApiData.food_dish_id, "quantity": this.quantity, "Name": this.foodName, "Price": this.totalDishPriceAfterAddons, "originalPrice": this.optionPriceBasedOnQuantity,
        "option_id": this.option_ID, "option_name": this.option_names, "option_price": this.option_prices, "rdaoop_id": this.select_value_rdoop, "epos_product_id": this.epos_id
      })
      sessionStorage.setItem('orders-data', JSON.stringify(this.orders));
      sessionStorage.setItem('addon-orders', JSON.stringify(this.orders))
      this.closeModal();
    }
    else {
      this.orders.push({
        "food_dish_id": this.ApiData.food_dish_id, "quantity": this.quantity, "Name": this.foodName, "Price": this.totalDishPriceAfterAddons, "originalPrice": this.optionPriceBasedOnQuantity,
        "option_id": this.option_ID, "option_name": this.option_names, "option_price": this.option_prices, "rdaoop_id": this.select_value_rdoop, "epos_product_id": this.epos_id
      })
      sessionStorage.setItem('orders-data', JSON.stringify(this.orders));
      sessionStorage.setItem('addon-orders', JSON.stringify(this.orders))

      this.closeModal();
    }
    this.sub = interval(500)
      .subscribe((val) => {
      })
    this.cartLength = sessionStorage.getItem('orders-data');
    this.length = JSON.parse(this.cartLength)
    this.counts = this.length?.map((item: any) => {
      return item.quantity
    })
    this.lengths = this.counts?.length
    this._snackBar.open(this.foodName + " added to cart");
    setTimeout(() => {
      this._snackBar.dismiss();
    }, 2000);
    let data = {
      lengths: this.lengths,
      food_dish_id: this.ApiData.food_dish_id
    }
    this.bottomSheetRef.dismiss(data);
    // }
  }

  orderse
  dietPref = []
  getQuantity(dishId) {
    for (let orderse of this.orders) {
      if (orderse.food_dish_id == dishId) {
        return orderse.quantity
      }
    }
  }

  selectedOptId
  option_names
  option_prices
  indexValueAddon
  showSomeData: boolean = false
  showAddonData: boolean = false;
  addonBasedonOptionId = []
  epos_id
  sendAddondetails(optionIds, optionsName, optionsPrice, index) {
    if (this.addonListShow) {
      if (this.dishAddonArray.length > 0) {
        this.dishAddonArray.splice(0, this.dishAddonArray.length)
      }
      if (this.select_value_rdoop.length > 0) {
        this.select_value_rdoop.splice(0, this.select_value_rdoop.length)
      }
      this.option_ID = optionIds;
      this.option_names = optionsName;
      this.option_prices = optionsPrice;
      this.indexValueAddon = index
      this.selectedOptId = optionIds
      this.dishAddonArray = [];
      let addonObj = {
        restaurant_id: this.restoID,
        dish_id: this.ApiData.food_dish_id,
        quantity: 1,
        option_id: optionIds,
        dish_addon_id: this.dishAddonArray
      }
      this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
        this.totalDishPriceAfterAddons = res.result.totalDishPrice;
        this.addonBasedonOptionId = res.result.addonBasedonOptionId;
        if (this.addonBasedonOptionId) {
          this.showAddonData = true;
          this.addonListShow = false;
        } else {
          this.addonListShow = false;
          this.showAddonData = true;
        }
        this.changeDetectorRef.detectChanges();
      }, (err: any) => {
        console.log(err)
      })
    }
    else {
      this.totalDishPriceAfterAddons = optionsPrice
      this.optionPriceBasedOnQuantity = optionsPrice
      this.option_ID = optionIds;
      this.option_names = optionsName;
      this.option_prices = optionsPrice;
      this.indexValueAddon = index;
      this.selectedOptId = optionIds;
      this.disableAddBtn = false;
    }
  }

  value_coupon(val) {
    return parseFloat(val).toFixed(2);
  }
  valueAddonMoney(val) {
    return parseFloat(val).toFixed(1);
  }

  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }
  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}

@Component({
  selector: 'bottom-sheet-category',
  templateUrl: 'bottom-sheet-category.html',
  styleUrls: ['./food-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class BottomSheetCategory implements OnInit {
  ApiData
  restoID
  foodName
  options = []
  defaultSelected = 0
  selectedoption
  allAllergDatas
  dish_ID
  quantity = 1
  allDietDatas
  UserCondition
  addonList = []
  first_price
  option_ID
  spiceRating
  conditionToDisaply: boolean = false;
  More
  more
  orders = []
  select_value = []
  Addon_select
  addonListShow: boolean = false;
  food_dishes_option_id
  onchangePrice = true
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private router: Router,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef, private bottomSheetRef: MatBottomSheetRef<BottomSheetCategory>, public httpSv: HttpService) {
    this.data = data
  }
  ngOnInit() {
    this.UserCondition = sessionStorage.getItem('access_token');
    this.restoID = sessionStorage.getItem('restoId');
  }

  closeModal() {
    this.bottomSheetRef.dismiss(this.ShowStarters);
  }
  catValue
  ShowStarters
  getCategoryValue(item) {
    this.ShowStarters = item
    this.bottomSheetRef.dismiss(this.ShowStarters)
  }

  getCategoryValues() {
    this.ShowStarters = 'All';
    this.bottomSheetRef.dismiss(this.ShowStarters)
  }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }
  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}

@Component({
  selector: 'bottom-sheet-key-ingredients',
  templateUrl: 'bottom-sheet-key-ingredients.html',
})

export class BottomSheetKeyIngredients implements OnInit {
  constructor(
    public httpSv: HttpService,
    private _bottomSheet: MatBottomSheet,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetKeyIngredients>,
  ) {

  }
  imgLoadFlag: boolean = false
  UserCondition
  restoID
  foodDishName
  foodDishId
  token
  ids
  tableids
  overAllText
  tasteScoreArray
  overAllRating
  personalisedRating
  personalised_text
  allergensRatingObj
  allergenss_name
  review_code
  review_total
  total_review_count
  total_rating_count
  DishIdName
  description
  ingredients
  price
  step1: boolean = false;
  step2: boolean = false;
  step3: boolean = false;
  step4: boolean = false;
  step5: boolean = false;
  overallBool: boolean = false;
  personalisedBool: boolean = false;
  showReviewsAndRatings: boolean = false;
  dishIdDetail: any[] = [];
  allergensListArray: any[] = [];
  allergens: any[] = [];
  allergensOptions: any[] = [];
  unsuitableDietary: any[] = [];
  unsuitableDietaryOption: any[] = [];
  tags: any[] = [];
  cerealsAndPulses: any[] = [];
  fruitsAndVegetables: any[] = [];
  spicesAndHerbs: any[] = [];
  others: any[] = [];
  // discrOption:boolean = false
  fruitsAndVegetablesFlag: boolean = false
  spicesAndHerbsFlag: boolean = false
  cerealsAndPulsesFlag: boolean = false
  othersFlag: boolean = false
  dishImage: any = '';
  imageFlag = true;
  mediaFlag = false;
  nutriInfoFlag: boolean = true
  ngOnInit() {
    this.UserCondition = sessionStorage.getItem('access_token');
    if (sessionStorage.getItem('restoIDCopy'))
      this.restoID = sessionStorage.getItem('restoIDCopy');
    else
      this.restoID = sessionStorage.getItem('restoId');
    this.foodDishName = this.data.foodDishName;
    this.foodDishId = this.data.foodDishId;
    this.token = sessionStorage.getItem('access_token');
    this.ids = sessionStorage.getItem('restoIds')
    this.tableids = sessionStorage.getItem('tableIds')
    sessionStorage.setItem("dishId", this.foodDishId)
    if (this.data.discription) {
      this.step4 = true;
      //   setTimeout(()=>{this.goToStep4()},0)
    }
    else if (this.data.media) {
      this.step5 = true;
    }
    else {
      this.step1 = true;

    }
    if (!this.data.nutriInfoFlag) this.nutriInfoFlag = false
    this.getAllDetailsOfReviews();
    this.getDishDetailsOfParticularId();
    this.getDishKeyIngredients();
    // if(this.data.discription){
    //   setTimeout(()=>{this.goToStep4()},0)
    // }
    console.log(this.data)
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    // if(this.data.discription){
    //   setTimeout(()=>{this.goToStep4()},0)
    // }
  }

  mediaChangeFunc(type) {
    if (type == 'img') this.imageFlag = true
    else if (type == 'audio') this.imageFlag = false
  }
  makeLoadFlagFalse() {
    this.imgLoadFlag = true
    console.log(this.imgLoadFlag, 'asdsdaf')
  }
  goToStep1() {
    this.step1 = true;
    this.step2 = false;
    this.step3 = false;
    this.step4 = false;
    this.step5 = false;
  }

  goToStep2() {
    this.step1 = false;
    this.step2 = true;
    this.step3 = false;
    this.step4 = false;
    this.step5 = false;
  }

  goToStep3() {
    this.step1 = false;
    this.step2 = false;
    this.step3 = true;
    this.step4 = false;
    this.step5 = false;
  }

  goToStep4() {
    this.step1 = false;
    this.step2 = false;
    this.step3 = false;
    this.step4 = true;
    this.step5 = false;
  }

  goToStep5() {
    this.step1 = false;
    this.step2 = false;
    this.step3 = false;
    this.step4 = false;
    this.step5 = true;
  }

  checkOverAll() {
    this.overallBool = true;
    this.personalisedBool = false;
  }

  checkPersonalized() {
    this.personalisedBool = true;
    this.overallBool = false;
  }

  getAllDetailsOfReviews() {
    let getRatingObj = {
      restaurant_id: this.restoID,
      dish_id: this.foodDishId
    }
    this.httpSv.getReviewDishWise(this.restoID, this.foodDishId).subscribe((res: any) => {
      if (res['status'] == 'TRUE') {
        this.showReviewsAndRatings = true;
        this.changeDetectorRef.detectChanges();
        this.overallBool = true;
        this.personalisedBool = false;
        this.tasteScoreArray = res['result']?.taste_score;
        this.overAllText = this.tasteScoreArray?.overall_text;
        this.overAllRating = this.tasteScoreArray?.overall;
        this.personalisedRating = this.tasteScoreArray?.personalised;
        this.personalised_text = this.tasteScoreArray?.personalised_text;
        this.allergensRatingObj = res['result']?.allergens_rating;
        this.allergensListArray = this.allergensRatingObj?.allergens_list;
        this.allergenss_name = this.allergensListArray[0]?.allergens_id;
        this.review_code = this.allergensRatingObj?.review_code;
        this.review_total = this.allergensRatingObj?.review_total;
        this.total_review_count = this.tasteScoreArray?.total_review_count;
        this.total_rating_count = this.tasteScoreArray?.total_rating_count;
      }
      this.changeDetectorRef.detectChanges();
      // if(this.data.discription){
      //   this.goToStep4()
      // }
    }, (err: any) => {
      this.showReviewsAndRatings = false;
      console.log(err);
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
    this.changeDetectorRef.detectChanges();
  }

  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        }
      }
    )
  }

  gotoTasteRatingsPage(foodDishName) {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/horizontal/taste-ratings'], { queryParams: { dishname: foodDishName } });
  }

  gotoAllergyRatingsPage(foodDishName) {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/horizontal/allergy-ratings'], { queryParams: { dishname: foodDishName } })
  }

  getDishDetailsOfParticularId() {
    this.httpSv.getAllDishInfo(this.restoID, this.foodDishId).subscribe((res: any) => {
      if (res['status'] == true) {
        this.dishIdDetail = res.result;
        this.DishIdName = res.result.name;
        this.description = res.result.description;
        this.ingredients = res.result.ingredients;
        this.price = res.result.price;
        this.allergens = res.result.allergens;
        this.allergensOptions = res.result.allergensOptions
        this.unsuitableDietary = res.result.dietary;
        this.unsuitableDietaryOption = res.result.dietaryOption;
        this.tags = res.result.tags;
        if (res.result.image) {
          this.dishImage = res.result.image
          this.mediaFlag = true
        }
        this.changeDetectorRef.detectChanges();
        // if(this.data.discription){
        //   setTimeout(()=>{this.goToStep4()},0)
        // }
      }
    }, ((err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
    )
  }

  getDishKeyIngredients() {
    this.httpSv.getDishIngredients(this.restoID, this.foodDishId).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.changeDetectorRef.detectChanges();
        if (res.result.data.Cereals_and_Pulses)
          this.cerealsAndPulses = res.result.data.Cereals_and_Pulses;
        if (res.result.data.Fruits_and_Vegetables)
          this.fruitsAndVegetables = res.result.data.Fruits_and_Vegetables;
        if (res.result.data.Others)
          this.others = res.result.data.Others;
        if (res.result.data.Spices_and_Herbs)
          this.spicesAndHerbs = res.result.data.Spices_and_Herbs;
        console.log(this.spicesAndHerbs)
        if (this.fruitsAndVegetables.length > 0) this.fruitsAndVegetablesFlag = true
        if (this.spicesAndHerbs.length > 0) this.spicesAndHerbsFlag = true
        if (this.cerealsAndPulses.length > 0) this.cerealsAndPulsesFlag = true
        if (this.others.length > 0) this.othersFlag = true

        this.changeDetectorRef.detectChanges();
      }
    }, ((err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    }))
  }

  postLikes(ingName) {
    let likeObj = {
      name: ingName,
      status: 'Yes'
    }
    let disLikeObj = {
      name: ingName,
      status: 'No'
    }
    this.httpSv.postDisLikesDish(disLikeObj).subscribe(async (res: any) => {
      await this.httpSv.postLikeDish(likeObj).subscribe(async (res: any) => {
        await this.getDishKeyIngredients();
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      })
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  postDisLikes(ingName) {
    let disLikeObj = {
      name: ingName,
      status: 'Yes'
    }
    let likeObj = {
      name: ingName,
      status: 'No'
    }
    this.httpSv.postLikeDish(likeObj).subscribe(async (res: any) => {
      await this.httpSv.postDisLikesDish(disLikeObj).subscribe(async (res: any) => {
        await this.getDishKeyIngredients();
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      })
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }
  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}

declare var FB: any;
@Component({
  selector: 'bottom-sheet-food-guest-login',
  templateUrl: 'bottom-sheet-food-guest-login.html',
})

export class BottomSheetFoodGuestLogin implements OnInit {
  cookie: string = 'NotAccepted'
  showmore: boolean = false
  clickinfo: boolean = true
  showVerifyOtp: boolean = false;
  getOtpForm: FormGroup;
  getnameForm: FormGroup
  expirationInMin
  email
  showEmail: boolean = true;
  otpResponse: any;
  showNameScreen: boolean = false;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetFoodGuestLogin>,
    private router: Router,
    public httpSv: HttpService,
    private changeDetectorRef: ChangeDetectorRef,
    private _bottomSheet: MatBottomSheet,
    private _snackBar: MatSnackBar,
    private loginService: LoginService) {
  }

  ngOnInit() {

    this.otpForm();
    this.UserNameForm();
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    let temp = document.getElementById("googleLOGINIcon");
    // temp.classList.remove("googleBtn-toggle");
    console.log(temp)
    console.log(document.getElementById("googleLoginIcon"))
    document.getElementById("googleLoginIcon").appendChild(temp);
  }

  otpForm() {
    this.getOtpForm = new FormGroup({
      userEmail: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]),
    })
  }

  UserNameForm() {
    this.getnameForm = new FormGroup({
      userName: new FormControl('', [Validators.required])
    })
  }

  Privacy() {
    this.closeModal();
    this.router.navigate(['/public/privacy'])
  }
  terms() {
    this.closeModal();
    this.router.navigate(['/public/terms'])
  }
  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  userEmailStored
  is_new_user;
  submitted: boolean = false;
  sendOtpByEmail() {
    this.submitted = true;
    if (this.getOtpForm.valid) {
      this.showEmail = !this.showEmail
      this.googleIconRestore()
      sessionStorage.removeItem("access_token");
      this.userEmailStored = this.getOtpForm.value.userEmail;
      this.httpSv.sendOtpByEmail(this.getOtpForm.value.userEmail).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          const b64 = res.result.data; // base64 string
          const decodedStr = atob(b64); // -> JSON string (if it was encoded as plain ASCII/UTF-8)
          const decodedObj = JSON.parse(decodedStr);

          // this.otpData = decodedObj.otp;

          this.otpResponse = decodedObj.otp;
          this.is_new_user = decodedObj.is_new_user;
        }
        else {
        }
      })
    } else {

    }

  }
  get_OTP(value) {
  }

  authToken
  hideVerifyOTP: boolean = false
  showErrorMessage: boolean = false
  verifyOtp(e) {
    if (this.otpResponse == parseInt(this.otpValue)) {
      let otpObj = {
        email: this.getOtpForm.value.userEmail,
        otp: this.otpValue,
      }
      this.httpSv.verifyOTPUser(otpObj).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.closeModal();
          if (res.result.userDetails.name == null) {
            this.authToken = res.result.token;
            sessionStorage.setItem('access_token', this.authToken);
            this.userEmails = res.result.userDetails.email;
            sessionStorage.setItem("email", this.userEmails);
            this._bottomSheet.open(BottomSheetGuestProfile, {
              disableClose: true
            });
          } else {
            this.authToken = res.result.token;
            sessionStorage.setItem('access_token', this.authToken);
            this.userNames = res.result.userDetails.name;
            sessionStorage.setItem("userName", this.userNames)
            this.userEmails = res.result.userDetails.email;
            sessionStorage.setItem("email", this.userEmails);
            this.router.navigate(['/horizontal/food-menu'])
          }
        }
        else {
        }
      })
    } else {
      this.showErrorMessage = true;
    }
  }


  otpValue
  onOtpChange(e) {
    if (e.length == 4) {
      this.otpValue = e;
      this.verifyOtp(e);
    }
  }

  resendOtp() {
    this.showEmail = !this.showEmail
    this.sendOtpByEmail();
  }

  UserCondition: boolean = false;
  getUsernameAndOtp() {
    let otpObj = {
      email: this.getOtpForm.value.userEmail,
      otp: this.otpValue,
      name: this.getnameForm.value.userName
    }
    this.httpSv.verifyOTPUser(otpObj).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.closeModal();
        this.authToken = res.result.token;
        this.setUserName(res.result);
        sessionStorage.setItem('access_token', this.authToken);
        this.bottomSheetRef.dismiss();
        this.UserCondition = true
      }
      else {
      }
    })
  }
  userNames
  userEmails
  userEmailSplitted
  setUserName(data) {
    this.userNames = data.userDetails.name;
    this.userEmails = data.userDetails.email;
    sessionStorage.setItem("userName", this.userNames)
    sessionStorage.setItem("email", this.userEmails);

  }

  get f() {
    return this.getOtpForm.controls;
  }

  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
    if (document.getElementById("googleLOGINIcon"))
      this.googleIconRestore()
  }
  googleIconRestore() {
    let temp = document.getElementById("googleLOGINIcon");
    if (temp != null) {
      console.log(document.getElementById("googleLoginIcon"))
      document.getElementById("googleIconContainer").appendChild(temp);
    }
  }
  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
  async signInWithFB() {
    FB.login(
      async function (response) {
        //Checking the login is successfully done or not
        if (response.authResponse) {
          // Calling another facebook api for getting the data of user and storing the data in local storage
          FB.api(
            "/me",
            { locale: "en_US", fields: "name, email" },
            function (response) {
              // if facebook account does not have email associated with the account setting it to null
              sessionStorage.setItem(
                "fb_email",
                response["email"] ? response["email"] : "null"
              );
              sessionStorage.setItem("fb_userName", response["name"]);
            }
          );
        }
      },

      { scope: "public_profile,email" }
    );
    // Using setTimeout for calling our socialLogin api in synchronous manner
    // await setTimeout(() => {
    //   let fbUserEmail = sessionStorage.getItem("fb_email");
    //   let fbUserName = sessionStorage.getItem("fb_userName");
    //   let fbObj = {
    //     email: fbUserEmail,
    //     name: fbUserName,
    //     source: "Facebook",
    //   };
    //   // If email is null, declining the login with a notification else calling our api
    //   if (fbObj.email == "null") {
    //     this._snackBar.open("Can't proceed with Facebook.Try different way");
    //     setTimeout(() => {
    //       this._snackBar.dismiss();
    //     }, 3000);
    //     FB.logout(function (response) {});
    //   } else if(sessionStorage.getItem("email")) {
    //     this.loginService.postLoginSocial(fbObj).subscribe(
    //       (response) => {
    //         if (response["status"] == true) {
    //           this.authToken = response.result.authToken;
    //           sessionStorage.setItem("access_token", this.authToken);
    //           this.router.navigate(["/horizontal/aggregator"]);
    //         }
    //       },
    //       (err: any) => {
    //         console.log("Facebook configuration error:", err);
    //       }
    //     );
    //   }
    // }, 1200);
    await this.loginByFacebook()
  }
  loginByFacebook() {

    let data = interval(1000).subscribe(() => {
      let flag = sessionStorage.getItem("fb_userName")
      if (flag) {

        data.unsubscribe()
        let fbUserEmail = sessionStorage.getItem("fb_email");
        let fbUserName = sessionStorage.getItem("fb_userName");
        let fbObj = {
          email: fbUserEmail,
          name: fbUserName,
          source: "Facebook",
        };
        // If email is null, declining the login with a notification else calling our api
        console.log(sessionStorage.getItem("email"))
        if (fbObj.email == "null") {
          this._snackBar.open("Can't proceed with Facebook.Try different way");
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 3000);
          FB.logout(function (response) { });
        } else if (sessionStorage.getItem("fb_email")) {
          this.loginService.postLoginSocial(fbObj).subscribe(
            (response) => {
              if (response["status"] == true) {
                this.authToken = response.result.authToken;
                sessionStorage.setItem("access_token", this.authToken);
                this.router.navigate(["/horizontal/food-menu"]);
              }
            },
            (err: any) => {
              console.log("Facebook configuration error:", err);
            }
          );
        }
        data.unsubscribe()
      }
      else if (sessionStorage.getItem("access_token")) {
        data.unsubscribe();
      } else {
      }
    })
  }
}


@Component({
  selector: 'bottom-sheet-guest-profile',
  templateUrl: 'bottom-sheet-guest-profile.html',
})
export class BottomSheetGuestProfile implements OnInit {
  getProfileForm: FormGroup;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetGuestProfile>,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    public httpSv: HttpService) {
  }

  ngOnInit() {
    this.profileForm();
  }

  profileForm() {
    this.getProfileForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
    })
  }
  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  userNames
  updateUserProfile() {
    let profileObj = {
      name: this.getProfileForm.value.userName
    }
    this.httpSv.updateProfile(profileObj).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.closeModal();
        sessionStorage.setItem("userName", this.getProfileForm.value.userName);
        this.router.navigate(['/vertical/food-menu'])
      } else {

      }
    },
      (err: any) => {
        console.log(err)
      })
  }

  get f() {
    return this.getProfileForm.controls;
  }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }
  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}

@Component({
  selector: 'bottom-sheet-ratings',
  templateUrl: 'bottom-sheet-ratings.html',
})
export class BottomSheetRatings implements OnInit {

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetRatings>,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private _bottomSheet: MatBottomSheet,
    public httpSv: HttpService) {
    this.data = data
  }

  foodDishName
  restoID
  overallBool: boolean = true;
  personalisedBool: boolean = false;
  foodDishId
  token
  tableids
  ids
  UserCondition
  ngOnInit() {
    // this.changeDetectorRef.detach(); 
    this.UserCondition = sessionStorage.getItem('access_token');
    this.restoID = sessionStorage.getItem('restoId');
    this.foodDishName = this.data.foodDishName;
    this.foodDishId = this.data.foodDishId;
    this.token = sessionStorage.getItem('access_token');
    this.ids = sessionStorage.getItem('restoIds')
    this.tableids = sessionStorage.getItem('tableIds')
    sessionStorage.setItem("dishId", this.foodDishId)
    this.getAllDetailsOfReviews();
    this.checkOverAll();
    // this.changeDetectorRef.detach(); 
  }


  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  overAllText
  tasteScoreArray
  overAllRating
  personalisedRating
  personalised_text
  allergensRatingObj
  allergenss_name
  review_code
  review_total
  allergensListArray: any[] = [];
  showReviewsAndRatings: boolean = false;
  total_review_count
  total_rating_count
  getAllDetailsOfReviews() {
    let getRatingObj = {
      restaurant_id: this.restoID,
      dish_id: this.foodDishId
    }
    this.httpSv.getReviewDishWise(this.restoID, this.foodDishId).subscribe((res: any) => {
      if (res['status'] == 'TRUE') {
        this.showReviewsAndRatings = true;
        this.changeDetectorRef.detectChanges();
        this.overallBool = true;
        this.personalisedBool = false;
        this.tasteScoreArray = res['result'].taste_score;
        this.overAllText = this.tasteScoreArray.overall_text;
        this.overAllRating = this.tasteScoreArray.overall;
        this.personalisedRating = this.tasteScoreArray.personalised;
        this.personalised_text = this.tasteScoreArray.personalised_text;
        this.allergensRatingObj = res['result'].allergens_rating;
        this.allergensListArray = this.allergensRatingObj.allergens_list;
        this.allergenss_name = this.allergensListArray[0].allergens_id;
        this.review_code = this.allergensRatingObj.review_code;
        this.review_total = this.allergensRatingObj.review_total;
        this.total_review_count = this.tasteScoreArray.total_review_count;
        this.total_rating_count = this.tasteScoreArray.total_rating_count;
      }
      this.changeDetectorRef.detectChanges();
    }, (err: any) => {
      this.showReviewsAndRatings = false;
      console.log(err);
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }


  checkOverAll() {
    this.overallBool = true;
    this.personalisedBool = false;
  }

  checkPersonalized() {
    this.personalisedBool = true;
    this.overallBool = false;
  }

  GoToReviewspage(foodDishName) {
    if (this.UserCondition) {
      this.bottomSheetRef.dismiss();

      let queryParamsArray = [
        {
          dishname: foodDishName,
        }
      ]
      this.router.navigate(['/vertical/post-review'], {
        queryParams: {
          filter: JSON.stringify(queryParamsArray)
        }
      })
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
        disableClose: true
      });
    }
  }

  gotoTasteRatingsPage(foodDishName) {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/horizontal/taste-ratings'], { queryParams: { dishname: foodDishName } });
  }

  gotoAllergyRatingsPage(foodDishName) {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/horizontal/allergy-ratings'], { queryParams: { dishname: foodDishName } })
  }

  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        }
      }
    )
  }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }
  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }

}

@Component({
  selector: 'bottom-sheet-declaimer',
  templateUrl: 'bottom-sheet-declaimer.html',
})
export class BottomSheetDeclaimer implements OnInit {

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetDeclaimer>,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private _bottomSheet: MatBottomSheet,
    public httpSv: HttpService) {
    this.data = data
  }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }
  closePopUp() {
    sessionStorage.setItem('_declaimer', 'true')
    this.bottomSheetRef.dismiss();
  }
}





@Component({
  selector: 'bottom-allergen-list',
  templateUrl: 'bottom-allergen-list.html',
})

export class BottomAllegenList implements OnInit {
  constructor(
    public httpSv: HttpService,
    private _bottomSheet: MatBottomSheet,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomAllegenList>,
  ) { }
  ngOnInit(): void {
    this.allData = this.data
  }
  allData: any
  close() {
    this.bottomSheetRef.dismiss()
  }
}
@Component({
  selector: 'allergens-chart-dialog',
  templateUrl: 'allergens-chart-dialog.html',
  // encapsulation: ViewEncapsulation.None,
})

export class AllergensChartDialog implements OnInit {
  constructor(
    public httpSv: HttpService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AllergensChartDialog>,
  ) { }
  ngOnInit(): void {
    this.allergensData = this.data.restaurant_allergens;
    this.dishesData = this.data.dishes
    this.reviewedBy = this.data.restaurant_reviewed_details
  }
  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.
    const ele: any = document.getElementsByClassName('myfavourite_table')
    if (ele) {
      ele[0].style.borderCollapse = 'collapse'
      setTimeout(() => {
        ele[0].style.borderCollapse = 'separate'
      }, 500)
    }
  }
  reviewedBy: any = []
  allergensData: any = []
  dishesData: any = []
  allergensExist(dishAllergens: any, boxAllergens: any) {
    if (dishAllergens.some((obj: any) => obj.allergens_id == boxAllergens.allergens_id))
      return true
    else
      return false
  }
  getOptionAvailabel(dishAllergens: any, boxAllergens: any) {
    let ind = dishAllergens.findIndex((obj: any) => obj.allergens_id == boxAllergens.allergens_id)
    if (ind != -1) {
      return dishAllergens[ind].is_allergens_option
    }
    else return 0
  }
  formatDate(epoch: any) {
    if (epoch) {
      const date = new Date(epoch * 1000); // Convert epoch to milliseconds
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    }
    else return 'N/A'
  }
}


@Component({
  selector: 'unsuitable-bottomsheet',
  templateUrl: 'unsuitable-bottomsheet.html',
})

export class UnsuitableBottomSheet implements OnInit {
  constructor(
    public httpSv: HttpService,
    private _bottomSheet: MatBottomSheet,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<UnsuitableBottomSheet>,
  ) { }
  ngOnInit(): void {
    console.log(this.data)
    this.allergensData = this.data.apiData.allergens
    this.dpData = this.data.apiData.dietary_preference
    this.dishName = this.data.dish_name

  }
  allergensData: any
  dpData: any

  dishName
  close() {
    this.bottomSheetRef.dismiss()
  }
}




@Component({
  selector: 'allergen-msg-dialog',
  templateUrl: 'allergen-msg-dialog.html',
  // encapsulation: ViewEncapsulation.None,
})

export class AllergensMsgDialog implements OnInit {
  constructor(
    public httpSv: HttpService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AllergensMsgDialog>,
  ) { }
  ngOnInit(): void {

  }
  close() {
    this.dialogRef.close()
  }
}